'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Calendar, Clock } from 'lucide-react';
type HourRate = {
  hour: string;
  responseRate: number;
};
type DayRate = {
  day: string;
  responseRate: number;
};
type AnaliseTemporalData = {
  responseRateByHour: HourRate[];
  responseRateByDay: DayRate[];
  bestHour: HourRate;
  bestDays: DayRate[];
};
interface AnaliseTemporalProps {
  data: AnaliseTemporalData;
}
export const AnaliseTemporal: React.FC<AnaliseTemporalProps> = t0 => {
  const $ = _c(67);
  const {
    data
  } = t0;
  const [viewMode, setViewMode] = useState("hour");
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== data.bestDays || $[1] !== data.bestHour.hour || $[2] !== data.bestHour.responseRate || $[3] !== data.responseRateByDay || $[4] !== data.responseRateByHour || $[5] !== viewMode) {
    const DAY_MAP = {
      sun: "Dom",
      mon: "Seg",
      tue: "Ter",
      wed: "Qua",
      thu: "Qui",
      fri: "Sex",
      sat: "S\xE1b"
    };
    const chartData = viewMode === "hour" ? data.responseRateByHour.map(_temp) : data.responseRateByDay.map(item_0 => ({
      name: DAY_MAP[item_0.day.toLowerCase()] ?? item_0.day,
      Taxa: item_0.responseRate.toFixed(2)
    }));
    t8 = "flex h-full flex-col rounded-[16px] border border-neutral-100 bg-white p-[22px] shadow-sm";
    let t11;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div><h3 className="text-body-bold font-body-bold text-neutral-900">Taxa de resposta por horário e dia</h3><p className="text-caption font-caption text-subtext-color">Melhores horários e dias para envio com base no histórico da sua base</p></div>;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    let t12;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = () => setViewMode("hour");
      $[17] = t12;
    } else {
      t12 = $[17];
    }
    const t13 = `flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-all ${viewMode === "hour" ? "text-chart-primary bg-white shadow-sm" : "text-neutral-600 hover:text-neutral-900"}`;
    let t14;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <Clock className="h-4 w-4" />;
      $[18] = t14;
    } else {
      t14 = $[18];
    }
    let t15;
    if ($[19] !== t13) {
      t15 = <button onClick={t12} className={t13}>{t14}Por Hora</button>;
      $[19] = t13;
      $[20] = t15;
    } else {
      t15 = $[20];
    }
    let t16;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = () => setViewMode("day");
      $[21] = t16;
    } else {
      t16 = $[21];
    }
    const t17 = `flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-all ${viewMode === "day" ? "text-chart-primary bg-white shadow-sm" : "text-neutral-600 hover:text-neutral-900"}`;
    let t18;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <Calendar className="h-4 w-4" />;
      $[22] = t18;
    } else {
      t18 = $[22];
    }
    let t19;
    if ($[23] !== t17) {
      t19 = <button onClick={t16} className={t17}>{t18}Por Dia</button>;
      $[23] = t17;
      $[24] = t19;
    } else {
      t19 = $[24];
    }
    if ($[25] !== t15 || $[26] !== t19) {
      t9 = <div className="mb-4 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">{t11}<div className="flex rounded-lg bg-neutral-100 p-1">{t15}{t19}</div></div>;
      $[25] = t15;
      $[26] = t19;
      $[27] = t9;
    } else {
      t9 = $[27];
    }
    let t20;
    let t21;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = {
        top: 20,
        right: 30,
        left: 0,
        bottom: 5
      };
      t21 = <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E5E5" />;
      $[28] = t20;
      $[29] = t21;
    } else {
      t20 = $[28];
      t21 = $[29];
    }
    let t22;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
        fill: "#737373",
        fontSize: 12
      }} dy={10} />;
      $[30] = t22;
    } else {
      t22 = $[30];
    }
    let t23;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = <YAxis axisLine={false} tickLine={false} tick={{
        fill: "#737373",
        fontSize: 12
      }} tickFormatter={_temp2} />;
      $[31] = t23;
    } else {
      t23 = $[31];
    }
    let t24;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <Tooltip contentStyle={{
        borderRadius: "8px",
        border: "none",
        boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)"
      }} cursor={{
        fill: "#F5F5F5"
      }} />;
      $[32] = t24;
    } else {
      t24 = $[32];
    }
    let t25;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = <Legend wrapperStyle={{
        paddingTop: "20px"
      }} />;
      $[33] = t25;
    } else {
      t25 = $[33];
    }
    let t26;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = [4, 4, 0, 0];
      $[34] = t26;
    } else {
      t26 = $[34];
    }
    const t27 = viewMode === "hour" ? 20 : 40;
    let t28;
    if ($[35] !== t27) {
      t28 = <Bar dataKey="Taxa" name="Taxa de Resposta (%)" fill="#2a1b63" radius={t26} barSize={t27} />;
      $[35] = t27;
      $[36] = t28;
    } else {
      t28 = $[36];
    }
    const t29 = <ResponsiveContainer width="100%" height="100%"><BarChart data={chartData} margin={t20}>{t21}{t22}{t23}{t24}{t25}{t28}</BarChart></ResponsiveContainer>;
    if ($[37] !== t29) {
      t10 = <div className="h-[300px] w-full flex-1">{t29}</div>;
      $[37] = t29;
      $[38] = t10;
    } else {
      t10 = $[38];
    }
    t6 = "mt-4 flex gap-7 border-t border-neutral-100 pt-3.5";
    let t30;
    let t31;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t30 = <div className="flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-[6px] bg-[var(--kpi-icon-primary-bg)]"><Clock className="h-3 w-3" style={{
          color: "var(--kpi-icon-primary-fg)"
        }} /></div>;
      t31 = <div className="text-caption font-caption text-subtext-color uppercase">Melhor Horário</div>;
      $[39] = t30;
      $[40] = t31;
    } else {
      t30 = $[39];
      t31 = $[40];
    }
    const t32 = data.bestHour.hour;
    let t33;
    if ($[41] !== data.bestHour.responseRate) {
      t33 = data.bestHour.responseRate.toFixed(0);
      $[41] = data.bestHour.responseRate;
      $[42] = t33;
    } else {
      t33 = $[42];
    }
    if ($[43] !== data.bestHour.hour || $[44] !== t33) {
      t7 = <div className="flex items-center gap-2">{t30}<div>{t31}<div className="text-body-bold font-body-bold text-neutral-900">{t32} → {t33}%</div></div></div>;
      $[43] = data.bestHour.hour;
      $[44] = t33;
      $[45] = t7;
    } else {
      t7 = $[45];
    }
    t4 = "flex items-center gap-2";
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-[6px] bg-[var(--kpi-icon-success-bg)]"><Calendar className="h-3 w-3" style={{
          color: "var(--kpi-icon-success-fg)"
        }} /></div>;
      t3 = <div className="text-caption font-caption text-subtext-color uppercase">Melhores Dias</div>;
      $[46] = t3;
      $[47] = t5;
    } else {
      t3 = $[46];
      t5 = $[47];
    }
    t1 = "text-body-bold font-body-bold text-neutral-900";
    t2 = data.bestDays.map(d => DAY_MAP[d.day.toLowerCase()] ?? d.day).join(" e ");
    $[0] = data.bestDays;
    $[1] = data.bestHour.hour;
    $[2] = data.bestHour.responseRate;
    $[3] = data.responseRateByDay;
    $[4] = data.responseRateByHour;
    $[5] = viewMode;
    $[6] = t1;
    $[7] = t10;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t1 = $[6];
    t10 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[48] !== t1 || $[49] !== t2) {
    t11 = <div className={t1}>{t2}</div>;
    $[48] = t1;
    $[49] = t2;
    $[50] = t11;
  } else {
    t11 = $[50];
  }
  let t12;
  if ($[51] !== t11 || $[52] !== t3) {
    t12 = <div>{t3}{t11}</div>;
    $[51] = t11;
    $[52] = t3;
    $[53] = t12;
  } else {
    t12 = $[53];
  }
  let t13;
  if ($[54] !== t12 || $[55] !== t4 || $[56] !== t5) {
    t13 = <div className={t4}>{t5}{t12}</div>;
    $[54] = t12;
    $[55] = t4;
    $[56] = t5;
    $[57] = t13;
  } else {
    t13 = $[57];
  }
  let t14;
  if ($[58] !== t13 || $[59] !== t6 || $[60] !== t7) {
    t14 = <div className={t6}>{t7}{t13}</div>;
    $[58] = t13;
    $[59] = t6;
    $[60] = t7;
    $[61] = t14;
  } else {
    t14 = $[61];
  }
  let t15;
  if ($[62] !== t10 || $[63] !== t14 || $[64] !== t8 || $[65] !== t9) {
    t15 = <div className={t8}>{t9}{t10}{t14}</div>;
    $[62] = t10;
    $[63] = t14;
    $[64] = t8;
    $[65] = t9;
    $[66] = t15;
  } else {
    t15 = $[66];
  }
  return t15;
};
function _temp(item) {
  return {
    name: item.hour,
    Taxa: item.responseRate.toFixed(2)
  };
}
function _temp2(value) {
  return `${value}%`;
}